import { Fragment, ReactElement } from 'react';

import {
  Checkbox,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import { formatDateForLocale } from '@/utils';

import { Credit } from '../types';
import { useBoolean } from 'usehooks-ts';
import { ManageCreditDrawer } from './ManageCreditDrawer';
import { Status } from '@/components';
import {
  changeTableCheckIds,
  setUserIdFilter,
  useTableCheckIds,
} from '../store';

export const CreditsTableRow = (props: Credit): ReactElement => {
  const {
    value: shouldShowManageDrawer,
    toggle: toggleManageDrawer,
    setFalse,
  } = useBoolean();
  const checked = useTableCheckIds();

  const formattedLastActiveDate = formatDateForLocale(props.updatedAt);

  const handleCheck = () => {
    if (checked.includes(props.id))
      changeTableCheckIds(
        checked.filter((item) => {
          return item !== props.id;
        }),
      );
    else changeTableCheckIds([...checked, props.id]);
  };

  const handleOpenDrawer = () => {
    setUserIdFilter(props.id);
    toggleManageDrawer();
  };

  return (
    <Fragment>
      <TableRow>
        {/* Checkbox */}
        <TableCell padding="checkbox">
          <Checkbox
            onClick={() => handleCheck()}
            checked={checked.includes(props.id)}
          />
        </TableCell>

        {/* ID */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props.id}
          </Typography>
        </TableCell>

        {/* Full name */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props.firstName} {props.lastName}
          </Typography>
        </TableCell>

        {/* Balance */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props.creditBalance}
          </Typography>
        </TableCell>

        {/* Email */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props.email}
          </Typography>
        </TableCell>

        {/* Last Active Date */}
        <TableCell>{formattedLastActiveDate}</TableCell>

        {/* Status */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            <Status status={props.status} useIcon />
          </Typography>
        </TableCell>

        {/* Action button(s) */}
        <TableCell>
          <IconButton
            aria-label="Action Button"
            size="small"
            color="inherit"
            onClick={handleOpenDrawer}
          >
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        </TableCell>
      </TableRow>

      <ManageCreditDrawer value={shouldShowManageDrawer} setFalse={setFalse} />
    </Fragment>
  );
};
